import { Button, Text } from "@kunduz/ui-atoms";
import { trackEvent } from "@kunduz/utility-analytics";
import Link from "next/link";
import React, { ReactElement } from "react";
import styles from "./buttonGroupV2.module.scss";
import { CommonComponentProps } from "../../config";
import classNames from "classnames";
import { getCmsIcon } from "@kunduz/utility-common";

export const ButtonGroupV2 = (props: ButtonGroupV2Props): ReactElement => {
  const {
    buttons,
    title,
    options: {
      alignmentDesktop,
      alignmentMobile,
      alignmentTablet,
      sizeDesktop,
      sizeMobile,
      sizeTablet,
    },
  } = props;

  const renderButtonIcon = (badgeIcon: string) => {
    const Icon = getCmsIcon(badgeIcon);

    if (!Icon) {
      return null;
    }

    return <Icon />;
  };

  function handleClicked(label?: string) {
    trackEvent("Hero Component CTA Button Clicked", {
      label,
    });
  }

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
        styles[`${alignmentDesktop}AlignmentDesktop`],
        styles[`${alignmentMobile}AlignmentMobile`],
        styles[`${alignmentTablet}AlignmentTablet`],
      )}
    >
      {title && <div className={styles.title}>{title}</div>}
      {buttons?.length > 0 && (
        <div className={styles.buttonsContainer}>
          {buttons?.map((button, index) => (
            <Button
              variant="secondary"
              color="gray"
              size="sm"
              as={Link}
              href={button.url}
              onClick={() => handleClicked(button.label)}
              key={index}
              className={styles.button}
            >
              {button.badgeIcon && renderButtonIcon(button.badgeIcon)}
              <Text variant="textsm" weight="semibold">
                {button.label}
              </Text>
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export interface ButtonGroupV2Props extends CommonComponentProps {
  buttons: {
    label: string;
    url: string;
    badgeIcon?: string;
  }[];
  title: string;
}
